module.exports = __webpack_public_path__ + "img/button1.33ec440d.png";